import { getProvider } from '@optimex-xyz/trade-wallet-sdk'

export const getEVMBalance = async (networkId: string, address: string) => {
  try {
    const provider = getProvider(networkId)
    const balance = await provider.getBalance(address)
    return balance.toString()
  } catch (e) {
    throw new Error(`Unable to getEVMBalance: ${e}`)
  }
}
